import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-full flex items-center justify-center bg-black overflow-hidden relative">
      <motion.div
        initial={{ scale: 0, rotate: -15 }}
        animate={{ scale: 1.1, rotate: 0 }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="w-full h-full flex flex-col items-center justify-center relative z-10 cursor-pointer"
        onClick={() => navigate('/')}
      >
        <motion.div
          animate={{ scale: [1, 1.02, 1] }}
          transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
          className="text-white text-center flex flex-col items-center"
        >
          <motion.h2 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 0.8 }}
            className="text-2xl md:text-3xl font-black uppercase tracking-[0.5em] mb-4 text-green-400"
          >
            BeachHouse
          </motion.h2>
          
          <div className="relative">
            <h1 className="text-[32vw] md:text-[28rem] font-black font-montserrat tracking-tighter leading-none italic select-none">
              2025
            </h1>
            {/* Multi-layered kickass glow effects */}
            <h1 className="absolute inset-0 text-[32vw] md:text-[28rem] font-black font-montserrat tracking-tighter leading-none italic blur-[60px] opacity-70 text-green-500 animate-pulse select-none -z-10">
              2025
            </h1>
            <h1 className="absolute inset-0 text-[32vw] md:text-[28rem] font-black font-montserrat tracking-tighter leading-none italic blur-xl opacity-40 text-white select-none -z-10">
              2025
            </h1>
          </div>

          <motion.div
            animate={{ y: [0, 10, 0], opacity: [0.3, 0.8, 0.3] }}
            transition={{ repeat: Infinity, duration: 2 }}
            className="mt-4 px-10 py-4 bg-white/5 backdrop-blur-md border border-white/10 rounded-full"
          >
            <p className="text-xs md:text-sm font-black tracking-[0.6em] text-white">TAP TO UNWRAP</p>
          </motion.div>
        </motion.div>
        
        {/* Dynamic environmental glows */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100vw] h-[100vw] bg-green-500/10 rounded-full blur-[200px] -z-20" />
      </motion.div>

      {/* Background kinetic pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" 
           style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '60px 60px' }} />
    </div>
  );
};

export default LandingPage;